/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SharedMobileMoreWaysToBrowse_viewer$ref = any;
export type BuySharedMoreWaysToBrowse_viewer$ref = any;
export type BuySharedMoreWaysToBrowse_viewer = {
    readonly " $fragmentRefs": SharedMobileMoreWaysToBrowse_viewer$ref;
    readonly " $refType": BuySharedMoreWaysToBrowse_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedMoreWaysToBrowse_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedMobileMoreWaysToBrowse_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'ae12104c23d4c930cf693ab0b1890bc1';
export default node;
